export default "__VITE_ASSET__CXHPMpex__"